import React, { useEffect, useState } from "react";
import OperatingSystemForm from "./OperatingSystemForm";
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { parseURL } from "../../sc-utilities";
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from "./store/operatingSystemActions";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';
import {updateKey} from "../TypicalProblem/TypicalProblemForm";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }
});

const OperatingSystemEdit = props => {
    const { classes, operatingSystem, onFetchOperatingSystemInit, activeCustomer, translations, permissions, onEditOperatingSystem } = props;
    const [data, setData] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            await props.onFetchOperatingSystem({ ActiveCustomerID: activeCustomer, OperatingSystemID: parseURL(window.location.href).operatingSystemID })
            setData(false)
        }
        fetchData();
        return () => {
            onFetchOperatingSystemInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async data => {
        let objestToSend = {...data};
        if (objestToSend["Key"] === "" || objestToSend["CustomerID"] === 'custom') {
            objestToSend["Key"] = null;
        }
        objestToSend["CustomerID"] === "system" ? objestToSend["CustomerID"] = null    :   objestToSend["CustomerID"] = activeCustomer;
        objestToSend["OperatingSystemID"] = operatingSystem.OperatingSystemID;
        let result = await onEditOperatingSystem({ ...objestToSend, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack()
        }
    };

    let initialValues = {
        Name: operatingSystem.Name || "",
        LongName: operatingSystem.LongName || "",
        CustomerID: operatingSystem?.CustomerID ? "custom"   :   "system",
        Key: operatingSystem ? operatingSystem.Key ? operatingSystem.Key : operatingSystem.Name && operatingSystem?.CustomerID ? updateKey(operatingSystem.Name) : '' : ''
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            LongName: Yup.string().required("Required"),
            Key: Yup.string().required("Required"),
        },
        FormTitle: translations["edit_operating_system"] || "Edit operating system",
        ButtonSubmit: hasPermission(permissions, 'system_operating_system_save') || (hasPermission(permissions, "operating_system_save") && operatingSystem.CustomerID)
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>
            {!data ?
                <OperatingSystemForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    translations={translations}
                    permissions={permissions}
                    CustomerIDPreviousState={operatingSystem?.CustomerID ? 'custom'   :   'system'}
                    fromEdit={true}
                />
                : <CircularProgress
                    variant="determinate"
                    color="primary"
                    size={28}
                />}
        </Paper>

    );
};
const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        operatingSystem: state.setting.operatingSystems && state.setting.operatingSystems.loaded ? state.setting.operatingSystems.loaded : {},
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchOperatingSystemInit: operatingSystem => dispatch(actions.loadOperatingSystemInit(operatingSystem)),
        onFetchOperatingSystem: operatingSystem => dispatch(actions.loadOperatingSystem(operatingSystem)),
        onEditOperatingSystem: operatingSystem => dispatch(actions.editOperatingSystem(operatingSystem)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(OperatingSystemEdit));
